import HomeLayout from './components/HomeLayout';

export default [
    {
        path: '/',
        component: HomeLayout
    }
];
